import {
	allows,
	PermissionMatrixName,
	PermissionMatrix,
} from '@netx/core-permissions/utils/allows';
import {PermissionName} from '../constants';
import {currentUserIsAdmin} from '../enablers/currentUserIsAdmin';
import {legacyPermissionsEnabled} from './legacyPermissionsEnabled';

export {PermissionMatrixName} from '@netx/core-permissions/utils/allows';
export {PermissionName} from '../constants';

export type IPermissionsAllowParams = {
	permissionMatrixName: PermissionMatrixName;
	permissionMatrix: PermissionMatrix;
	permissionName: PermissionName;
	permissions: PermissionName[];
};

export const permissionsAllow = (params: IPermissionsAllowParams) => {
	if (currentUserIsAdmin()) return true;
	if (legacyPermissionsEnabled())
		return allows(params.permissionMatrix, params.permissionMatrixName);
	if (params.permissionName === PermissionName.VIEW) return true;
	return params.permissions?.includes(params.permissionName);
};
